/* unplugin-vue-components disabled */import { render } from "./popupButtom.vue?vue&type=template&id=6f3a4b37&scoped=true"
import script from "./popupButtom.vue?vue&type=script&lang=js"
export * from "./popupButtom.vue?vue&type=script&lang=js"

import "./popupButtom.vue?vue&type=style&index=0&id=6f3a4b37&scoped=true&lang=css"

import exportComponent from "E:\\work\\weitu_land_page_h5\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3a4b37"]])

export default __exports__